var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2596 4.84616H7.58655C6.07307 4.84616 4.84616 6.07307 4.84616 7.58654V18.2596C4.84616 19.7731 6.07307 21 7.58655 21H18.2596C19.7731 21 21 19.7731 21 18.2596V7.58654C21 6.07307 19.7731 4.84616 18.2596 4.84616Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1298 4.84615L17.1538 3.69231C17.1518 2.97889 16.8675 2.29527 16.363 1.7908C15.8586 1.28633 15.175 1.00203 14.4615 1H4.07692C3.26161 1.00241 2.48039 1.32736 1.90387 1.90387C1.32736 2.48039 1.00241 3.26161 1 4.07692V14.4615C1.00203 15.175 1.28633 15.8586 1.7908 16.363C2.29527 16.8675 2.97889 17.1518 3.69231 17.1538H4.84615",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9231 9.07692V16.7692",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7692 12.9231H9.07692",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateTask);
export default __webpack_public_path__ + "static/media/duplicate_task.8bc4e615c35de17afdb28869430c9eb5.svg";
export { ForwardRef as ReactComponent };